import Vue from 'vue';
import request from '../../request';

function inferData(occurrence) {
  let confirmed = 0;
  let waiting = 0;
  let canceled = 0;
  let rejected = 0;
  let fullPrice = 0;

  occurrence.bookings.data.forEach((booking) => {
    if (booking.state_id === 1) waiting += 1;
    if (booking.state_id === 2 && booking.has_been_paid) {
      confirmed += 1;
      fullPrice += booking.total_price;
    }
    if (booking.state_id === 3) canceled += 1;
    if (booking.state_id === 4) rejected += 1;
  });
  return { confirmed, waiting, canceledP: canceled, rejected, fullPrice };
}

export default {
  namespaced: true,
  state: {
    data: [],
    indexes: [],
    single: {},
  },
  mutations: {

    set(state, data) {
      Vue.set(state, 'indexes', []);
      data.forEach((occurrence) => {
        const inferedData = inferData(occurrence);
        state.indexes.push(occurrence.id);
        Object.assign(occurrence, inferedData);
      });
      Vue.set(state, 'data', data);
    },
    setSingle(state, occurrence) {
      const inferedData = inferData(occurrence);
      Object.assign(occurrence, inferedData);
      Vue.set(state, 'single', occurrence);
    },
    removeBooking(state, bookingCode) {
      const newBookings = [];
      if (typeof state.single.bookings !== 'undefined') {
        if (state.single.bookings.data.length > 0) {
          state.single.bookings.data.forEach((booking) => {
            if (booking.booking_code !== bookingCode) {
              newBookings.push(booking);
            }
          });
        }
        Object.assign(state.single.bookings, { data: newBookings });
      }
    },
  },
  actions: {

    get(context) {
      const username = context.rootState.user.data.username;
      const url = `${process.env.API_URL}activity_calendar_occurrence`;
      request.make({
        type: 'GET',
        url,
        data: { username },
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('set', res.body.data);
          context.dispatch('bookingPromoter/setWaitingFromOccurrences', res.body.data, { root: true });
        }
      });
    },
    getSingle(context, id) {
      const url = `${process.env.API_URL}activity_calendar_occurrence/${id}`;
      request.make({
        type: 'GET',
        url,
        data: { include: 'bookings,activity' },
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setSingle', res.body.data);
        }
      });
    },
    removeBooking(context, bookingCode) {
      context.commit('removeBooking', bookingCode);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/occurrences.js